import fetcher from "./http";

export default {
    attachNewTag(appCode, saleId, tag) {
        return new Promise((resolve, reject) => {
            fetcher(`/api/v1/${appCode}/sales/${saleId}/tags`, {
                method: "POST",
                body: JSON.stringify(tag),
            })
                .then((response) =>
                    response.ok
                        ? response.json()
                        : response.json().then((err) => reject(err))
                )
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },
    removeTag(appCode, saleId, tagId) {
        return new Promise((resolve, reject) => {
            fetcher(`/api/v1/${appCode}/sales/${saleId}/tags/${tagId}`, {
                method: "DELETE",
            })
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    },
    getTags(appCode, saleId) {
        return new Promise((resolve, reject) => {
            fetcher(`/api/v1/${appCode}/sales/${saleId}/tags`, {
                method: "GET",
            })
                .then((response) =>
                    response.ok
                        ? response.json()
                        : response.json().then((err) => reject(err))
                )
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        });
    },
}
